<template>
    <div>

        <div v-if="id">
            <h1 v-if="state.object.data.territory_id != 0">{{ state.object.data.territory_name }}</h1>
            <Details :data='state.object.data' />
            <Targets />
        </div>

        <Search v-else :hideFields='true' />

        <button class="btn btn-warning" @click="syncSalesToTerritories">Synchronize Sales data to Territories</button>
    </div>
</template>

<script>

    import { store } from '@/store/BusinessObject.store.js';
    import { territoryStore } from './Territory.store.js';
    import Search from '@/components/businessObjects/utils/Search';
    import Details from '@/components/businessObjects/utils/Details';
    import Targets from './Targets';

    export default {
        name: "Container",
        data() {
            return {
                state: store.state,
                territoryState: territoryStore.state,
            }
        },
        props: ['id'],
        components: {
            Search,
            Details,
            Targets
        },
        created() {
            store.initialize(this.territoryState);
            this.state.nav.hideUpload = true;
            this.load();
        },
        methods: {
            load: function() {
                if (this.id){
                    store.load(this.id)
                        .then(() => this.$appStore.setTitle([this.state.object.data.territory_name, this.state.titlePlural]));
                }
            },
            syncSalesToTerritories: function() {
                let scope = this;
                store.apiWithObjectLoad('sync_sales_to_territories', {}, 'object.data').then(function() {
                    scope.companyID = 0;
                })
            }
        },
        watch: {
            id: function (){
                this.load();
            }
        }
    }
</script>